/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlBooleanFieldAnswer
 */
export interface ControlBooleanFieldAnswer {
    /**
     * 
     * @type {string}
     * @memberof ControlBooleanFieldAnswer
     */
    field_type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlBooleanFieldAnswer
     */
    value: boolean;
}

/**
 * Check if a given object implements the ControlBooleanFieldAnswer interface.
 */
export function instanceOfControlBooleanFieldAnswer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ControlBooleanFieldAnswerFromJSON(json: any): ControlBooleanFieldAnswer {
    return ControlBooleanFieldAnswerFromJSONTyped(json, false);
}

export function ControlBooleanFieldAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBooleanFieldAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field_type': !exists(json, 'field_type') ? undefined : json['field_type'],
        'value': json['value'],
    };
}

export function ControlBooleanFieldAnswerToJSON(value?: ControlBooleanFieldAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field_type': value.field_type,
        'value': value.value,
    };
}

